module.exports = __webpack_public_path__ + "img/894759867.e20c7ff6.jpg";